var variantNameElement = $(".product-form__option-name");
// const languageRegex = /^[a-zA-ZäöüßÄÖÜ0-9 ]*$/;
// const languageNoRegex = /[^a-zA-ZäöüßÄÖÜ0-9 ]/g
const languageRegex = /^[a-zA-ZäöüßÄÖÜ0-9 \u4e00-\u9fa5\u0600-\u06FF]*$/;
const languageNoRegex = /[^a-zA-ZäöüßÄÖÜ0-9 \u4e00-\u9fa5\u0600-\u06FF]/g;

const arabicRegex = /[\u0600-\u06FF]/g;
const georgianRegex = /[\u10A0-\u10FF]/g;
const emojiRegex = /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F700}-\u{1F77F}]|[\u{1F780}-\u{1F7FF}]|[\u{1F800}-\u{1F8FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{2763}]|[\u{2765}-\u{27BF}]|[\u{1F1E6}-\u{1F1FF}]|[\u{1F191}-\u{1F251}]|[\u{1F004}]|[\u{1F0CF}]|[\u{1F170}-\u{1F171}]|[\u{1F17E}-\u{1F17F}]|[\u{1F18E}]|[\u{3030}]|[\u{2B50}]|[\u{2B55}]|[\u{2934}-\u{2935}]|[\u{2B06}-\u{2B07}]|[\u{2B05}]|[\u{27A1}]|[\u{1F500}-\u{1F53D}]|[\u{1F54B}-\u{1F567}]/gu;
var formElement = document.querySelector(".product-form form");
formElement.additionalObject = ['',''];
var MessageInput = $(".adp-item-message-content>input")
var AddToCartBtn = document.querySelector("#MainPaymentContainer #AddToCart")
var AddToCartStickyBtn = document.querySelector("#StickyAddToCart")
var BundleAddToCartBtn = document.querySelector(".bundle-form-atc")
var StickyAddToCartOverlay = document.querySelector("#StickyAddToCartOverlay")
var requiredFactorCount = window.Shopify.requiredFactorCount || 0;
const pslOptionYes = "Yes";
const pslOptionNo = "No";
const pslOptionTitle = "Personalize";
const bpslOptionTitle = "Box Personalize";
const bp_pslOptionTitle = "Bag Personalize";
const luxeBoxString = "Luxe Box Gift Set";
const standardboxString = "Standard Box Gift Set";
// christmas
const christmasboxString = "Xmas Box Gift Set";
//

var variantNameElementIndex = 0;
variantNameElement.each(function (index) {
  if ($(this).text() == `${pslOptionTitle}:` || $(this).text() == `${bpslOptionTitle}:` || $(this).text() == `${bp_pslOptionTitle}:`) {
    var that = this;
    let pslVariantValueElement = $(".product-form__option-value:eq(" + index + ")")
    let pslOptionElement = $(`.personalize-option input:eq(${variantNameElementIndex})`);
    let pslVariantOptionbox = pslVariantValueElement.parent().siblings(".block-swatch-list");


    if($(this).text() == `${bpslOptionTitle}:`){
      $(`input[value='${luxeBoxString}']`).on("click",function(){
        $(".personalize-container.box").show();//
        $(".xmas-box-remain-bar").hide();
      })
      $(`input[value='${standardboxString}']`).on("click",function(){
        pslVariantOptionbox.find(`input[value='${pslOptionNo}']`).click()
        $(".personalize-container.box").hide();
        $(".xmas-box-remain-bar").hide();
      })
      //christmas
      $(`input[value='${christmasboxString}']`).on("click",function(){
        // pslVariantOptionbox.find(`input[value='${pslOptionNo}']`).click()
        // $(".personalize-container.box").hide();
        // $(".xmas-box-remain-bar").show();
      })
      //
    }
    //init 
    $(document).ready(function () {
      if(requiredFactorCount == 0){
        requiredFactorCount = window.Shopify.requiredFactorCount;
      }
    })
    //personalization input tip
    $(`.pslOption-input-text:eq(${variantNameElementIndex})`).on("input paste keydown", function () {
      let textContent = $(this).val();
      let characterLen = textContent.length;
      let previewBtn = $(this).closest(".personalize-container").find(".pslOption-input-text-preview-btn")
      let tipNoArabicWord = $(this).closest(".personalize-container").find(".personalize-name .tip-noArabicWord")
      let tipOnlyEG = $(this).closest(".personalize-container").find(".personalize-name .tip-onlyEG")
      let tipNoMore = $(this).closest(".personalize-container").find(".personalize-name .error-box.tip-nomore")
      let tipRequired =$(this).closest(".personalize-container").find(".personalize-name .error-box.tip-required")
      let tipNoArabicShow = false;
      if(tipNoArabicWord.length != 0){
        tipNoArabicShow = !tipNoArabicWord.hasClass("error-hidden")
      }
      let tipNoMoreShow = !tipNoMore.hasClass("error-hidden")
      let tipRequiredShow = !tipRequired.hasClass("error-hidden")
      let tipOnlyEGShow = !tipOnlyEG.hasClass("error-hidden")
      let AddToCartBtnDisabledAttr = AddToCartBtn.getAttribute("disabled")
      if(emojiRegex.test(textContent)){
        textContent = textContent.replace(emojiRegex, '')
        $(this).val(textContent)
      }
      
      if($(that).text() == `${bpslOptionTitle}:` && !languageRegex.test(textContent)){
        textContent = textContent.replace(languageNoRegex,'')
        // if(!tipOnlyEGShow && characterLen != 0){
        //   tipOnlyEG.removeClass("error-hidden");
        // }
        $(this).val(textContent)
      }else{
        // if(tipOnlyEGShow){
        //   tipOnlyEG.addClass("error-hidden");
        // }
      }
      // if($(that).text() == `${pslOptionTitle}:` && arabicRegex.test(textContent)){
      //   textContent = textContent.replace(arabicRegex, '')
      //   if(!tipNoArabicShow && characterLen != 0){
      //     tipNoArabicWord.removeClass("error-hidden");
      //   }
      //   $(this).val(textContent)
      // }else{
      //   if(tipNoArabicShow){
      //     tipNoArabicWord.addClass("error-hidden");
      //   }
      // }

      characterLen = textContent.length;
      //input frame
      if (characterLen < 1 && !tipRequiredShow) {
        
        if(tipNoMoreShow){
          tipNoMore.addClass("error-hidden")
          if(requiredFactorCount!=0){
            requiredFactorCount--;
          }
        }
        tipRequired.removeClass("error-hidden")
        previewBtn.css("display","none")
        
        if ($(pslOptionElement).is(':checked')) {
          if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
            AddToCartBtn.setAttribute("disabled", "personalization");
          if(BundleAddToCartBtn){
            BundleAddToCartBtn.setAttribute("disabled", "personalization");
          }
            AddToCartStickyBtn.setAttribute("disabled", "personalization");
            StickyAddToCartOverlay.style.display = "block"
            requiredFactorCount++;
            console.log("requiredFactorCount",requiredFactorCount)
          }
        }
      }
      else if (characterLen >= 1 && characterLen <= 12) {
        if (tipRequiredShow || tipNoMoreShow) {
          tipRequired.addClass("error-hidden");
          tipNoMore.addClass("error-hidden")
          if(requiredFactorCount!=0){
            requiredFactorCount--;
          }
          console.log("requiredFactorCount", requiredFactorCount)
        }
          previewBtn.css("display","inline-block")
          if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
            if (requiredFactorCount == 0) {
              AddToCartBtn.removeAttribute("disabled")
              if(BundleAddToCartBtn){
                BundleAddToCartBtn.removeAttribute("disabled")
              }
              AddToCartStickyBtn.removeAttribute("disabled")
              StickyAddToCartOverlay.style.display = "none"
            }
          // }
        }
      }
      else if (characterLen > 12 && !tipNoMoreShow) {
        if(tipRequiredShow){
          tipRequired.addClass("error-hidden")
          if(requiredFactorCount!=0){
            requiredFactorCount--;
          }
        }
        $(this).val(textContent.trim());
        tipNoMore.removeClass("error-hidden");
        if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
          previewBtn.css("display","none")
          AddToCartBtn.setAttribute("disabled", "personalization");
          
          if(BundleAddToCartBtn){
            BundleAddToCartBtn.setAttribute("disabled", "personalization");
          }
          AddToCartStickyBtn.setAttribute("disabled", "personalization");
          StickyAddToCartOverlay.style.display = "block"
          requiredFactorCount++;
          console.log("requiredFactorCount",requiredFactorCount)
        }
      }
    })
    $(".pslOption-input-text-preview-btn").on("click",function(){
        let previewInput = $(this).closest(".personalize-container").find(".pslOption-input-text")
        // previewBtn.css("display","inline-block")
        let preview_bg_url = "https://cdn.shopify.com/s/files/1/0617/7652/7613/files/boxcustom-preview-bg.jpg"
        const preview_type = previewInput.data("type");
        const bag_type = previewInput.data("bag-title");
        const userName = previewInput.val();
        let font_size = '46px';
        let font_family = "Wildflower";
        let font_style = `${font_size} ${font_family}`;
        let font_color = '#e9e4ce';
        let font_color_img = 'white';
        let offsetX = -6;
        let offsetY = 6;
        let letterHeight = 50;
        let custom_title = 'Your Custom Box'
        let rotate_deg = -6;
        if(preview_type == 'bag'){
          font_size = '40px';
          custom_title = "Your Custom Hug & Go"
          preview_bg_url = "https://cdn.shopify.com/s/files/1/0617/7652/7613/files/mossy-psl-preview-bg.jpg"
          if(bag_type.indexOf("Mossy") != -1){
            offsetX = 40;
            offsetY = 160;
          }else if(bag_type.indexOf("Babu") != -1 || bag_type=="Moonkie Hug & Go™ Duo –  Elephant Backpack & Dinosaur Plush"){
            offsetX = 40;
            offsetY = 100;
            rotate_deg = -4;
            preview_bg_url = "https://cdn.shopify.com/s/files/1/0617/7652/7613/files/babu-psl-preview-bg.jpg"
          }else if(bag_type.indexOf("Lilac") != -1){
            offsetX = 30;
            offsetY = 90;
            rotate_deg = -7;
            font_color_img = 'red';
            font_color = '#9D5349';
            preview_bg_url = "https://cdn.shopify.com/s/files/1/0617/7652/7613/files/Unicorn_personalized.jpg"
          }else if(bag_type.indexOf("Rexie") != -1){
            offsetX = 40;
            offsetY = 150;
            rotate_deg = -8;
            preview_bg_url = "https://cdn.shopify.com/s/files/1/0617/7652/7613/files/Dino_personalized.jpg"
          }else if(bag_type.indexOf("Logan") != -1 || bag_type== "Moonkie Hug & Go™ Duo –  Highland Cow Backpack & Reindeer Plush"){
            offsetX = 10;
            offsetY = 100;
            rotate_deg = -7;
            font_color_img = 'red';
            font_color = '#9D5349';
            preview_bg_url = "https://cdn.shopify.com/s/files/1/0617/7652/7613/files/Cow_personalized.jpg"
          }else if(bag_type.indexOf("Rosie") != -1 || bag_type=="Moonkie Hug & Go™ Duo –  Bunny Backpack & Unicorn Plush"){
            rotate_deg = -7;
            offsetX = 20;
            letterHeight = 48;
            offsetY = 100;
            font_color_img = 'red';
            font_color = '#9D5349';
            preview_bg_url = "https://cdn.shopify.com/s/files/1/0617/7652/7613/files/roise-psl-preview-bg.jpg"
          }
        }else if(preview_type == 'xmas-box'){
          preview_bg_url = "https://cdn.shopify.com/s/files/1/0617/7652/7613/files/xmas-boxcustom-preview-bg.jpg";
          font_family = "Plantagenet Cherokee";
        }else{
          font_family = "Plantagenet Cherokee"
        }
        if(arabicRegex.test(userName) ){
          font_family = "DUBAI";
        }
        if(userName.length > 6 && userName.length < 10){
          font_size = '34px';
          letterHeight = 42;
        }else if( userName.length > 10 ){
          font_size = '28px';
          letterHeight = 40;
        }
        Swal.fire({
            title:custom_title,
            width:"40rem",
            html: `<canvas id="canvas" style="width:100%" width="800" height="800"></canvas>
            <button class="customCloseBtn hidden-tablet-and-up swal2-styled"><svg id="_pic_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><defs><style>.cls-1{fill:#fff;}</style></defs><g id="_pic_1-2"><path class="cls-1" d="M25,47.63158c12.49895,0,22.63158-10.13263,22.63158-22.63158S37.49895,2.36842,25,2.36842,2.36842,12.50105,2.36842,25s10.13263,22.63158,22.63158,22.63158ZM25,50C11.19289,50,0,38.8071,0,25S11.19289,0,25,0s25,11.1929,25,25-11.1929,25-25,25ZM26.80631,25l9.49,9.49c.46247.46247.46247,1.21227,0,1.67474s-1.21227.46247-1.67474,0l-9.49-9.49-9.49,9.49c-.46247.46247-1.21227.46247-1.67474,0s-.46247-1.21227,0-1.67474l9.49-9.49-9.49-9.49c-.46247-.46247-.46247-1.21227,0-1.67474s1.21227-.46247,1.67474,0l9.49,9.49,9.49-9.49c.46247-.46247,1.21227-.46247,1.67474,0s.46247,1.21227,0,1.67474l-9.49,9.49Z"/></g></svg></button>
          `,
            customClass: {
                popup: 'box-custom-popup'
            },
            backdrop: 'rgba(0, 0, 0, 0.5)',
            showConfirmButton: false, 
            allowOutsideClick: true, 
            showCloseButton: true,
            didOpen: () => {
                document.querySelectorAll('.customCloseBtn').forEach((item)=>{
                  item.addEventListener('click', () => {
                      Swal.close();
                   });
                })
                const canvas = document.getElementById('canvas');
                const ctx = canvas.getContext('2d');
                const img = new Image();

                img.src = preview_bg_url;
                img.onload = () => {
                    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                    ctx.save();
                    font_style = `${font_size} ${font_family}`
                    if (preview_type == "box") {
                      var changeCW = canvas.width / 2 - 6;
                      var changeCH = canvas.height / 2 + 6;
                      var endCCW = (canvas.width - changeCW) / 2
                      var endCCWH = (canvas.height - changeCH)
                      ctx.translate(changeCW, changeCH);
                      const angle = 16.5 * Math.PI / 180;
                      ctx.rotate(angle);
                      var gradient = ctx.createLinearGradient(
                        endCCW + endCCW * Math.sin(10 * Math.PI / 180),
                        0,
                        endCCW - endCCW * Math.sin(15 * Math.PI / 180),
                        endCCWH / 2 + 10
                      );
                      gradient.addColorStop(0, '#8d4135');
                      gradient.addColorStop(0.35, '#dca295');
                      gradient.addColorStop(0.7, '#722c24');
                      ctx.fillStyle = gradient;
                      if (arabicRegex.test(userName)) {
                        ctx.font = `${font_size} DUBAI`;
                        ctx.textAlign = 'center';
                        ctx.fillText(userName, 0, 0);
                      } else {
                        ctx.textAlign = 'left';
                        let y = 0;
                        let totalWidth = 0;
                        for (let char of userName) {
                          if (/[\u4e00-\u9fa5]/.test(char)) {
                            ctx.font = `${font_size} KosefontP-t`;
                          } else {
                            ctx.font = `${font_size} Plantagenet Cherokee`;
                          }
                          totalWidth += ctx.measureText(char).width;
                        }
                        let x = -totalWidth / 2;
                        for (let char of userName) {
                          if (/[\u4e00-\u9fa5]/.test(char)) {
                            ctx.font = `${font_size} KosefontP-t`;
                          } else {
                            ctx.font = `${font_size} Plantagenet Cherokee`;
                          }
                          ctx.fillText(char, x, y);
                          x += ctx.measureText(char).width;
                        }
                      }
                      ctx.restore();
                    }else if (preview_type == "xmas-box") {
                      var changeCW = canvas.width / 2 ;
                      var changeCH = canvas.height / 2 + 12;
                      var endCCW = (canvas.width - changeCW) / 2
                      var endCCWH = (canvas.height - changeCH)
                      ctx.translate(changeCW, changeCH);
                      const angle = -0.6 * Math.PI / 360;
                      ctx.rotate(angle);
                      var gradient = ctx.createLinearGradient(
                        endCCW + endCCW * Math.sin(10 * Math.PI / 180),
                        0,
                        endCCW - endCCW * Math.sin(15 * Math.PI / 180),
                        endCCWH / 2 + 10
                      );
                      gradient.addColorStop(0, '#8d4135');
                      gradient.addColorStop(0.35, '#dca295');
                      gradient.addColorStop(0.7, '#722c24');
                      ctx.fillStyle = gradient;
                      ctx.textAlign = 'left';
                      let y = 0;
                      let totalWidth = 0;
                      for (let char of userName) {
                        if (/[\u4e00-\u9fa5]/.test(char)) {
                          ctx.font = `${font_size} KosefontP-t`;
                        } else {
                          ctx.font = `${font_size} Plantagenet Cherokee`;
                        }
                        totalWidth += ctx.measureText(char).width;
                      }
                      let x = -totalWidth / 2;
                      for (let char of userName) {
                        if (/[\u4e00-\u9fa5]/.test(char)) {
                          ctx.font = `${font_size} KosefontP-t`;
                        } else {
                          ctx.font = `${font_size} Plantagenet Cherokee`;
                        }
                        ctx.fillText(char, x, y);
                        x += ctx.measureText(char).width;
                      }
                      ctx.restore();
                    }
                    else if(preview_type == "bag"){
                      if(arabicRegex.test(userName)){
                        let startX_ = canvas.width / 2 + offsetX;
                        let centerY_ = canvas.height / 2 + offsetY;
                        ctx.translate(startX_, centerY_);
                        ctx.rotate(rotate_deg * Math.PI / 180);
                        ctx.font = font_style;
                        ctx.fillStyle = font_color;
                        ctx.textAlign = 'center';
                        ctx.fillText(userName, 0,0);
                        ctx.restore();
                      }else{
                        const letterSpacing = 1;
                        const letters = userName.split('');
                        const letterItems = [];
                        let loadedCount = 0;
                        letters.forEach((letter, index) => {
                          const imgLetter = new Image();
                          const originLetter = letter;
                          if(letter === letter.toUpperCase()){
                            letter = letter.toLowerCase();
                            imgLetter.src = `https://cdn.shopify.com/s/files/1/0617/7652/7613/files/cx_${letter}_up_${font_color_img}.png`;
                          }else{
                            imgLetter.src = `https://cdn.shopify.com/s/files/1/0617/7652/7613/files/cx_${letter}_${font_color_img}.png`;
                          }
                          imgLetter.onload = () => {
                            const aspectRatio = imgLetter.naturalWidth / imgLetter.naturalHeight;
                            const displayWidth = aspectRatio * letterHeight;
                            letterItems[index] = {
                              type: 'img',
                              value: imgLetter,
                              width: displayWidth
                            };
                            checkAllLoaded();
                          };

                          imgLetter.onerror = () => {
                            console.warn(`Image for letter ${originLetter} not found`);
                            ctx.font = font_style;
                            const metrics = ctx.measureText(originLetter);
                            const displayWidth = metrics.width;
                            letterItems[index] = {
                              type: 'text',
                              value: originLetter,
                              width: displayWidth
                            };
                            checkAllLoaded();
                          };
                        });

                        function checkAllLoaded() {
                          loadedCount++;
                          if (loadedCount === letters.length) drawAll();
                        }

                        function drawAll() {
                          const totalWidth = letterItems.reduce((sum, item) => sum + item.width + letterSpacing, -letterSpacing);
                          const startX = (canvas.width - totalWidth) / 2 + offsetX;
                          const centerY = canvas.height / 2 + offsetY;

                          ctx.save();
                          ctx.translate(startX + totalWidth / 2, centerY);
                          ctx.rotate((rotate_deg * Math.PI) / 180);
                          ctx.translate(-(startX + totalWidth / 2), -centerY);

                          let currentX = startX;

                          letterItems.forEach((item) => {
                            const drawY = centerY - letterHeight / 2;

                            if (item.type === 'img') {
                              ctx.drawImage(item.value, currentX, drawY, item.width, letterHeight);
                            } else if (item.type === 'text') {
                              ctx.font = font_style;
                              ctx.fillStyle = font_color;
                              ctx.textAlign = 'center';
                              ctx.textBaseline = 'middle';
                              ctx.fillText(item.value, currentX + item.width / 2, drawY + letterHeight / 2);
                            }

                            currentX += item.width + letterSpacing;
                          });
                          ctx.restore();
                        }
                      }
                    };
                  }
            }
        })
    })
    //init
    $(`.personalize-option:eq(${variantNameElementIndex}) input:radio`).on('click', function () {
      if ($(this).data("checked")) {
        $(this).data("checked", false)
        $(this).prop("checked", false)
        $(this).parent().find("input").trigger("change")
      } else {
        $(this).data("checked", true)
        $(this).prop("checked", true)
        $(this).parent().siblings().find("input").data("checked", false)
        $(this).parent().siblings().find("input").prop("checked", false)
        
        if(requiredFactorCount!=0){
          requiredFactorCount--;
        }
        console.log("requiredFactorCount",requiredFactorCount)
      }
    })
    //option bind to variant
    pslOptionElement.change(function (e) {
      let AddToCartBtnDisabledAttr = AddToCartBtn.getAttribute("disabled")
      const inputtext = $(this).closest(".personalize-container").find(".pslOption-input-text");
      const inputTextLen = inputtext.val().length;
      // const inputHasArabic = !arabicRegex.test(inputtext.val())
      if($(this).is(":checked")) {
        // pslVariantOptionbox.find(`input[value='${pslOptionYes}']`).click();
        $(this).closest(".personalize-container").find(".pslOption-input-text").attr("required", "true")
        $(this).closest(".personalize-container:not(.is-disabled)").find(".personalize-name").slideDown();
        $(this).closest(".personalize-container").find("input.form-name").attr("required", true)
        //
        $(this).closest(".personalize-container").find(".psl-tip-properties").val(pslOptionYes)
        //
        $(this).closest(".personalize-container").find(".pslOption-input-text").attr("form", window.product_form_id);
        $(this).closest(".personalize-container").find(".psl-tip-properties").attr("form", window.product_form_id);
        //
          requiredFactorCount++;
          console.log("requiredFactorCount",requiredFactorCount)
        if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
          AddToCartBtn.setAttribute("disabled", "personalization");
          AddToCartStickyBtn.setAttribute("disabled", "personalization");
          if(BundleAddToCartBtn){
            BundleAddToCartBtn.setAttribute("disabled", "personalization");
          }
          StickyAddToCartOverlay.style.display = "block"
        }
      } else {
        $(this).closest(".personalize-container").find(".pslOption-input-text").removeAttr("required")
        // pslVariantOptionbox.find(`input[value='${pslOptionNo}']`).click();
        $(this).closest(".personalize-container").find(".personalize-name").slideUp();
        $(this).closest(".personalize-container").find("input.form-name").removeAttr("required")
        $(this).closest(".personalize-container").find(".pslOption-input-text").val("");
        $(this).closest(".personalize-container").find(".pslOption-input-text").trigger("input")
        //
        $(this).closest(".personalize-container").find(".psl-tip-properties").val(pslOptionNo)
        //
        $(this).closest(".personalize-container").find(".pslOption-input-text").removeAttr("form")
        $(this).closest(".personalize-container").find(".psl-tip-properties").removeAttr("form")
        //
        // if(inputTextLen>0 && inputTextLen <=12 && !inputHasArabic){
        // }else{
          if(requiredFactorCount!=0){
          requiredFactorCount--;
          }
          console.log("requiredFactorCount",requiredFactorCount)
        // }
        if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
          if (requiredFactorCount == 0) {
            AddToCartBtn.removeAttribute("disabled")
            if(BundleAddToCartBtn){
                BundleAddToCartBtn.removeAttribute("disabled")
              }
            AddToCartStickyBtn.removeAttribute("disabled")
            StickyAddToCartOverlay.style.display = "none"
          }
        }
      }
    })
    // Variant bind to option
    pslVariantOptionbox.find(`input[value='${pslOptionNo}']`).on('click', function () {
      if ($(pslOptionElement).is(":checked")) {
        $(pslOptionElement).click();
      }
    });
    pslVariantOptionbox.find(`input[value='${pslOptionYes}']`).on('click', function () {
      if (!$(pslOptionElement).is(":checked")) {
        $(pslOptionElement).click();
      }
    });
    variantNameElementIndex++
  }
})

///////////////////////////////////christmas
var productList = {
  "3D Gift Message Card": {
    handle: 'personalized',
    "Blush": { id: "44082200215805", name: "Blush" },
    "Ether": { id: "44082200707325", name: "Ether" },
    "Xmas":{ id: "45773781205245", name: "Xmas" },
  },
  "Additional Daycare Labels": {
    handle: 'sticky-labels',
    "70 Labels": { id: "44703699435773", name: "70 Labels" },
    "280 Labels": { id: "44703699370237", name: "280 Labels" }
  }
}
var overCRTLimit = false;
function getCurrency(currencyTemp) {
  return (0).toLocaleString(
    "en-us",
    {
      style: 'currency',
      currency: currencyTemp,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }
  ).replace(/\d/g, '').trim()
}
var currency = getCurrency(window.Shopify.currency.active);
$(".additional-product-wrapper input:radio").on('click', function () {
  if ($(this).data("checked")) {
    $(this).data("checked", false)
    $(this).prop("checked", false)
    //
    $(this).removeAttr("checked")
    $(this).parent().find("input").trigger("change")
    if($(".additional-product-wrapper input:checkbox").data("checked")){
      $(".additional-product-wrapper input:checkbox").click();
    }
  } else {
    $(this).data("checked", true)
    $(this).prop("checked", true)
    //
    $(this).attr("checked", true)
    $(this).parent().siblings().find("input").data("checked", false)
    $(this).parent().siblings().find("input").prop("checked", false)
    $(this).parent().siblings().find("input").removeAttr("checked")
  }
})
$(".additional-product-wrapper input:checkbox").on('click', function () {
  let inputContent = $(this).closest("label").find(".adp-item-message-content");
  let adpitemContent = $(this).parent().siblings('.adp-item-content')
  let tipNoMore = $(".adp-item-message-content .error-box.tip-nomore")
  let tipNoMoreShow = !tipNoMore.hasClass("error-hidden")
  let AddToCartBtnDisabledAttr = AddToCartBtn.getAttribute("disabled")
  if ($(this).data("checked")) {
    $(this).data("checked", false)
    $(this).prop("checked", false)
    //
    inputContent.slideUp();
    // inputContent.find("input.input-text").removeAttr("required")
    //
    adpitemContent.find("input:radio[checked]").click()
    if(tipNoMoreShow){
      if(requiredFactorCount!=0){
      requiredFactorCount--;
      }
      if (requiredFactorCount == 0) {
        AddToCartBtn.removeAttribute("disabled")
        if(BundleAddToCartBtn){
                BundleAddToCartBtn.removeAttribute("disabled")
              }
        AddToCartStickyBtn.removeAttribute("disabled")
        StickyAddToCartOverlay.style.display = "none"
      }
    }
    window.Shopify.SeletedMessageCard.price = 0;
    $(document).trigger("card:changed",{});
  } else {
    $(this).data("checked", true)
    $(this).prop("checked", true)
    //
    // inputContent.find("input.input-text").attr("required", "true")
    inputContent.slideDown();
    //
    if(!adpitemContent.find('input[checked]').length){
      adpitemContent.find('input:radio')[0].click();
      
    if(tipNoMoreShow){
      if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
        AddToCartBtn.setAttribute("disabled", "personalization");
        
          if(BundleAddToCartBtn){
            BundleAddToCartBtn.setAttribute("disabled", "personalization");
          }
        AddToCartStickyBtn.setAttribute("disabled", "personalization");
        StickyAddToCartOverlay.style.display = "block"
        requiredFactorCount++;
        console.log("requiredFactorCount",requiredFactorCount)
      }
    }
  }
  }
})
$(".adp-item-swatch input").change(function () {
  let AddToCartBtnDisabledAttr = AddToCartBtn.getAttribute("disabled")
  if ($(this).attr("checked")) {
    var price = window.Shopify.Price[$(this).val()]
    window.Shopify.SeletedMessageCard = {
      price:price,
      id:productList[this.name][$(this).val()]["id"]
    };
    $(document).trigger("card:changed",{});
    var name = productList[this.name][$(this).val()]["name"]
    if (price) {
      $(this).closest(".additional-product-wrapper").find(".adp-item-title-value").html(name + " | " + currency + price)
    }
    else {
      $(this).closest(".additional-product-wrapper").find(".adp-item-title-value").html(name)
    }
    if (this.name == "3D Gift Message Card") {
      formElement.additionalObject[0] = { id: productList[this.name][$(this).val()]["id"], properties: {} }
      if(MessageInput.val()){
        formElement.additionalObject[0].properties.Message = MessageInput.val()
      }
    } else {
      formElement.additionalObject[1] = { id: productList[this.name][$(this).val()]["id"] }
    }
  }
  else {
    $(this).closest(".additional-product-wrapper").find(".adp-item-title-value").html("")
    if (this.name == "3D Gift Message Card") {
      formElement.additionalObject[0] = "";
      if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
        
        if (requiredFactorCount == 0) {
          AddToCartBtn.removeAttribute("disabled")
          if(BundleAddToCartBtn){
                BundleAddToCartBtn.removeAttribute("disabled")
              }
          AddToCartStickyBtn.removeAttribute("disabled")
          StickyAddToCartOverlay.style.display = "none"
        }
      }
    } else {
      formElement.additionalObject[1] = "";
    }
  }
})
$(".adp-item-message-content>input").on("input paste", function () {
  let characterLen = $(this).val().length;
  if(emojiRegex.test($(this).val())){
    let tempText = $(this).val().replace(emojiRegex, '')
    $(this).val(tempText)
  }
  if(georgianRegex.test($(this).val())){
    let tempText = $(this).val().replace(georgianRegex, '')
    $(this).val(tempText)
  }
  if(characterLen < 1){
    
    delete formElement.additionalObject[0].properties.Message;
  }else{
    formElement.additionalObject[0].properties.Message = $(this).val();
  }
  let tipNoMore = $(".adp-item-message-content .error-box.tip-nomore")
  let tipRequired = $(".adp-item-message-content .error-box.tip-required")
  let tipNoMoreShow = !tipNoMore.hasClass("error-hidden")
  let tipRequiredShow = !tipRequired.hasClass("error-hidden")
  let AddToCartBtnDisabledAttr = AddToCartBtn.getAttribute("disabled")
  if (characterLen < 1 && !tipRequiredShow) {
    if(overCRTLimit){
      requiredFactorCount--;
      overCRTLimit = false;
      console.log("requiredFactorCount",requiredFactorCount)
    }
    if (requiredFactorCount == 0) {
      AddToCartBtn.removeAttribute("disabled")
      if(BundleAddToCartBtn){
                BundleAddToCartBtn.removeAttribute("disabled")
              }
      AddToCartStickyBtn.removeAttribute("disabled")
      StickyAddToCartOverlay.style.display = "none"
    }
    tipRequired.removeClass("error-hidden")
    tipNoMore.addClass("error-hidden")
  }
  else if (characterLen >= 1 && characterLen <= 200 && (tipRequiredShow || tipNoMoreShow)) {
    overCRTLimit = false;
    if(tipNoMoreShow){
      tipNoMore.addClass("error-hidden")
      
      if(requiredFactorCount!=0){
        requiredFactorCount--;
      }
      console.log("requiredFactorCount",requiredFactorCount)
    }else if(tipRequiredShow){
      tipRequired.addClass("error-hidden");
    }
    if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
      if (requiredFactorCount == 0) {
        AddToCartBtn.removeAttribute("disabled")
        if(BundleAddToCartBtn){
                BundleAddToCartBtn.removeAttribute("disabled")
              }
        AddToCartStickyBtn.removeAttribute("disabled")
        StickyAddToCartOverlay.style.display = "none"
      }
    }
  }
  else if (characterLen > 200 && !tipNoMoreShow) {
    overCRTLimit = true;
    if(!tipNoMoreShow){
      tipNoMore.removeClass("error-hidden");
      tipRequired.addClass("error-hidden")
      requiredFactorCount++;
      console.log("requiredFactorCount",requiredFactorCount)
    }
    if (AddToCartBtnDisabledAttr != "" && AddToCartBtnDisabledAttr != "disabled") {
      AddToCartBtn.setAttribute("disabled", "personalization")
      
          if(BundleAddToCartBtn){
            BundleAddToCartBtn.setAttribute("disabled", "personalization");
          }
      AddToCartStickyBtn.setAttribute("disabled", "personalization");
      StickyAddToCartOverlay.style.display = "block"
    }
  }
})
// -------------------------------------------------------------
var bp_option_id_table = window.Shopify.bp_option_id_table;
if(bp_option_id_table != "" && $(".bp_option").length != 0){
  var bp_selected_array = [];
  var variantList = [];
  var bp_option_id_table_1 = bp_option_id_table.split("+")
  bp_option_id_table_1.forEach((element,index) => {
    bp_option_id_table_1[index] = element.split(";")
  });
  var bproduct = [{},{}]
  var bproduct_img = [{},{}]

  var bp_selected_array = [];
  bp_option_id_table_1.forEach((element,index) => {
    element.forEach((item,index1)=>{
      var variants = item.split("=")[0];
      if(index1 == 0){
        var variant = variants.split(",");
        variant.forEach((v,i)=>{
          if(!bp_selected_array[index]){
            bp_selected_array[index] = [];
          }
          bp_selected_array[index][i] = v;
        })
      }
      var id = item.split("=")[1].split("**")[0];
      var imgurl = item.split("=")[1].split("**")[1];
      bproduct[index][variants] = id;
      bproduct_img[index][variants]= imgurl
    })
  });
  var variant0 = ['',''];
  bp_selected_array.forEach((arr,index)=>{
    arr.forEach((item,i)=>{
      if(item != ''){
        if(i != 0){
          variant0[index] += ","
        }
        variant0[index] += item
      }
    })
  })
  formElement.additionalObject[2] = { id: bproduct[0][variant0[0]], properties: {} }
  formElement.additionalObject[3] = { id: bproduct[1][variant0[1]], properties: {} }

  $(".bp_option label").on("click",function(){
    var ipt = $(this).closest(".bp_option").find("input");
    var value = ipt.attr("value");
    var pindex = Number(ipt.attr("pindex"));
    var oindex = Number(ipt.attr("oindex"));
    var maptable = ipt.attr("map-table")
    if( oindex == 0 && maptable){
      const maptablearr = maptable.split(',').filter(item => item !== '');
      var nextow = $(this).closest(".option_wrapper").next(".option_wrapper")
      var ttlist = nextow.find('.block-swatch-list .bp_option');
      ttlist.hide();
      maptablearr.forEach(function(index,i) {
        if(i == 0){
          ttlist.eq(index).find("label").click();
        }
        ttlist.eq(index).show();
      });
    }
    bp_selected_array[pindex][oindex] = value
    var variant = ""
    bp_selected_array[pindex].forEach((item,i)=>{
      variant += item;
      if( i != bp_selected_array[pindex].length-1 ){
        variant += ",";
      }
    })
    $(this).closest('.bdlist_product_container').find('.bdlist_product_img').attr('src',bproduct_img[pindex][variant])
    $(this).closest('.bdlist_product_container').find('.bdlist_product_img').attr('srcset',bproduct_img[pindex][variant])
    formElement.additionalObject[pindex + 2] = { id: bproduct[pindex][variant], properties: {} }
  })
}
// -------------------------------------------------------------
const params = new URLSearchParams(window.location.search);
const imgIndex = parseInt(params.get("imgindex")) || 0;
if(imgIndex != 0){
  function waitForSwiperAndSlide() {
    const swiperContainer = document.querySelector(".pwzrswiper-container");
    if (swiperContainer && swiperContainer.swiper) {
      swiperContainer.swiper.slideTo(imgIndex);
    } else {
      setTimeout(waitForSwiperAndSlide, 100);
    }
  }
    waitForSwiperAndSlide();
}